<template>
  <div class="grid grid-cols-3 md:grid-cols-5 gap-16 py-16 mb-32" role="group" aria-label="Job Requirements">
    <template v-for="(item, index) in requirementsOptions" :key="index">
      <Requirement v-model:requirements-selections="selectedRequirements" :value="item.value" :aria-label="item.textLabel">
        <template #graphic>
          <component :is="item.icon" role="img" :aria-label="item.textLabel" />
        </template>
        {{ item.textLabel }}
      </Requirement>
    </template>
    <Requirement
      :selected="multilingualSelected"
      value="multilingual"
      is-button
      aria-haspopup="dialog"
      :aria-expanded="!hideModal"
      @click="toggleModal"
    >
      <template #graphic>
        <MultilingualIcon aria-label="Multilingual requirement" />
      </template>
      <span class="sr-only">Display language selection modal for </span>Multilingual
    </Requirement>
    <RequirementsMultilingual
      :hideModal="hideModal"
      :languages="selectedLanguages"
      aria-label="Language selection modal"
      @update:languages="selectedLanguages = $event"
      @hide-modal="hideModal = $event"
    />
  </div>
</template>

<script lang="ts">
import Requirement from './RequirementsToken.vue';
import { RequirementOption, requirementOptions } from './types/requirementsOptions';
import MultilingualIcon from '@/graphics/icons/MultilingualIcon.vue';
import RequirementsMultilingual from './RequirementsMultilingual.vue';
import { Requirements, Languages } from '@/store/modules/job/types';

export default {
  name: 'RequirementsSection',
  components: {
    Requirement,
    RequirementsMultilingual,
    MultilingualIcon,
  },
  props: {
    requirements: {
      type: Array as () => Requirements[],
      default: () => [],
    },
    languages: {
      type: Array as () => Languages[],
      default: () => [],
    },
  },
  data() {
    return {
      hideModal: true,
    };
  },
  computed: {
    requirementsOptions(): RequirementOption[] {
      return requirementOptions;
    },
    multilingualSelected(): boolean {
      return this.languages.length > 0;
    },
    selectedRequirements: {
      get(): Requirements[] {
        return this.requirements;
      },
      set(newValue: Requirements[]) {
        this.$emit('update:requirements', newValue);
      },
    },
    selectedLanguages: {
      get(): Languages[] {
        return this.languages;
      },
      set(newValue: Languages[]) {
        this.$emit('update:languages', newValue);
      },
    },
  },
  methods: {
    toggleModal(): void {
      this.hideModal = !this.hideModal;
    },
  },
};
</script>
